import { render, staticRenderFns } from "./PublishPanel.vue?vue&type=template&id=78358c90&scoped=true"
import script from "./PublishPanel.vue?vue&type=script&lang=js"
export * from "./PublishPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishPanel.vue?vue&type=style&index=0&id=78358c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78358c90",
  null
  
)

export default component.exports